import { Col, Container, Row } from "react-bootstrap";


import { Banner } from '@veeyaainnovatives/banner';
import { GoogleMap } from '@veeyaainnovatives/google-map';

import Bannerimg from '../assets/images/gallery/gallery-4.jpg';

import dots from '../assets/images/dots.png';
import ContactForm from "../components/sections/contact-form";
import contactData from '../assets/static_datas/contact.json';

const ContactUs = () => {
  
    const pageDetails = {
        title: "**Contact** Us",
        description: "When you reach out to us we will contact you within a day to talk more about your plans ",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: "Contact Us", link: "/contact-us" }
        ],
    }



    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
            <div className="body-wrap overflow-hidden mt-5">
                <section className='py-4'>
                    <div className="position-relative">
                        <div className="design-circle-our-worksection position-absolute"></div>
                        <Container className="mb-5" >
                           
                            <Row className="align-items-stretch">
                                <Col md={6}>
                                  <ContactForm requestType="contactus" />
                                </Col>
                                <Col md={6}>
                                    <GoogleMap
                                        embedUrl={contactData.map.embed_url}
                                        title="Our location"
                                        height={410}
                                        style={{
                                            borderRadius: 22,
                                            overflow: 'hidden'
                                        }}
                                    />
                                    <div className="contact-details-section mt-4">
                                        <div className="contact-detail-card">
                                            <div className="contact-icon phone-icon">
                                                <span className="fa fa-phone" />
                                            </div>
                                            <div className="contact-info">
                                                <p className="contact-label">Phone Number</p>
                                                <p className="contact-value">{contactData.phone}</p>
                                            </div>
                                        </div>
                                        <div className="contact-detail-card mt-3">
                                            <div className="contact-icon email-icon">
                                                <i className="fa fa-envelope" aria-hidden="true"></i>
                                            </div>
                                            <div className="contact-info">
                                                <p className="contact-label">Email Us</p>
                                                <p className="contact-value">{contactData.email}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                            </Row>

                        </Container>

                    </div>
                </section>

                <section className="section mt-0">
                    <Container >
                        <div className="prices-design position-relative">

                            <img src={dots} alt="dots" className="dots-top" />
                            <img src={dots} alt="dots" className="dots-bottom" />

                            <Row>
                                <Col xl={12}>
                                    <div className="text-center mb-4">
                                        <h2 className="prices-title">What will be our Process? </h2>

                                        <p className="prices-desc">You are one step closer to building your perfect product.</p>
                                    </div>
                                </Col>
                                <Col xl={12}>
                                    <Row className="my-4">
                                        <Col md={4}>
                                            <div className="price-card">
                                                <div className="plan-circle">
                                                    1
                                                </div>
                                                <h3 className="plan-title">We'll prepare a proposal</h3>
                                                <span className="plan-note">Required scope, timeline, and price estimations are key components to provide detailed project information.</span>

                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="price-card">
                                                <div className="plan-circle">
                                                    2
                                                </div>
                                                <h3 className="plan-title">Together we discuss it</h3>
                                                {/* <h3 className="plan-price">₹61,798</h3> */}
                                                <span className="plan-note">Let's get acquainted and discuss all project specifics — a quick call via Google Meet or Zoom works great.</span>

                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="price-card">
                                                <div className="plan-circle">
                                                    3
                                                </div>
                                                <h3 className="plan-title">Let's start building</h3>
                                                {/* <h3 className="plan-price">₹63,798</h3> */}
                                                <span className="plan-note no-margin-btm">Once the contract is signed and goals are set, we can start the first sprints.</span>

                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </div>
                    </Container>
                </section>

            </div>
        </>

    )
}

export default ContactUs;